import React, { useEffect, useState } from "react";
import header_Embelem from "../Assests_Url/Ncert_Black_Logo.png";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineLogout,
} from "react-icons/md";
import { FaChevronDown } from "react-icons/fa";
import {
  IoArrowUndoCircle,
  IoCloseOutline,
  IoPersonCircle,
} from "react-icons/io5";
import "../../src/components/BookFetch/Bookfetch.css";
import Input from "../components/input/Input";
import Subload from "../Assests_Url/subject_loading.gif";
import img1 from "../Assests_Url/super_img1.png";
import img2 from "../Assests_Url/super_img2.png";
import img3 from "../Assests_Url/super_img3.png";
import { BsArrowRightCircle } from "react-icons/bs";
import { RiArrowRightDoubleFill } from "react-icons/ri";
import PieChart from "../PieChart/PieChart";
import { LuPanelRightClose } from "react-icons/lu";
import Drawer from "react-modern-drawer";
import * as XLSX from "xlsx";
import moment from "moment";

import { SVGMap } from "react-svg-map";
import "react-svg-map/lib/index.css";
import India from "@svg-maps/india";
import {
  GetBookCountforAll,
  GetBookUnitSessions,
  getcityDropdown,
  getDashboardTable,
  getDashboardUserCount,
  getFeedbackReport,
  getInstitutionName,
  getInstitutionNameDashboard,
  getNcretBookDetails,
  GetSessionCountforAll,
  getStakeholdersTopCities,
  getStakeholdersTopStates,
  getStandardbyInstitutionName,
  getStatesDropdown,
  getSubjectfordashboard,
  getTableDataSuperAdmin,
  GetUnitCountforAll,
  GetUserListDashboard,
  reportGenerate,
} from "../Services/ApiService";
import Table from "../SmartTable/Table";
import { CFormLabel } from "@coreui/react-pro";
import MultiSelect from "react-multi-select-component";
import { GoHome } from "react-icons/go";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const genderOptions = [
  { value: "all", label: "All" },
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

const SuperAdminPage = () => {
  const [dropdown, setDropdown] = React.useState(false);
  const handleclick = () => {
    setDropdown(!dropdown);
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // <-- Legend hide pannittu chart edges la labels vara koodathu
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return context.label + ": " + context.raw; // tooltip la label + value display
          },
        },
      },
    },
  };

  // map

  const [selectedState, setSelectedState] = useState("");

  const handleDropdownChange = (option) => {
    setSelectedState(option ? option.value : "");
  };

  // Filter locations to show only selected state
  const filteredMap = {
    ...India,
    locations: selectedState
      ? India.locations.filter((loc) => loc.name === selectedState)
      : India.locations,
  };

  // const getLocationClass = (location) => {
  //   return location.name === selectedState ? "selected-state" : "";
  // };

  //map

  const [selectedState1, setSelectedState1] = useState("");

  const handleDropdownChange1 = (option) => {
    setSelectedState1(option ? option.value : "");
  };

  // Filter locations to show only selected state
  const filteredMap1 = {
    ...India,
    locations: selectedState1
      ? India.locations.filter((loc) => loc.name === selectedState1)
      : India.locations,
  };

  // const getLocationClass = (location) => {
  //   return location.name === selectedState ? "selected-state" : "";
  // };

  //map

  const [userCount, setUserCount] = useState([]);
  console.log(userCount, "userCount");
  const GetUserCounts = async () => {
    try {
      let response = await getDashboardUserCount();
      if (response.success === true) {
        setUserCount(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [topCites, setTopCites] = useState([]);
  const GetStakeholdersTopCities = async () => {
    try {
      let response = await getStakeholdersTopCities();
      if (response.success === true) {
        setTopCites(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [stateCountList, setStateCountList] = useState([]);
  const colors = [
    "rgba(255, 99, 132, 0.6)",
    "rgba(54, 162, 235, 0.6)",
    "rgba(255, 206, 86, 0.6)",
    "rgba(75, 192, 192, 0.6)",
    "rgba(153, 102, 255, 0.6)",
    "rgba(255, 159, 64, 0.6)",
    "rgba(199, 199, 199, 0.6)",
    "rgba(83, 102, 255, 0.6)",
    "rgba(40, 159, 64, 0.6)",
    "rgba(210, 99, 132, 0.6)",
    "rgba(20, 162, 235, 0.6)",
  ];

  const GetStakeholdersStatesCount = async () => {
    try {
      let response = await getStakeholdersTopStates();
      if (response.success === true) {
        setStateCountList(response.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  console.log(stateCountList, "topCites");

  useEffect(() => {
    GetUserCounts();
    GetStakeholdersTopCities();
    GetStakeholdersStatesCount();
  }, []);

  const [showMainContent, setShowMainContent] = useState(true);
  const [showSidePage, setShowSidePage] = useState(false);

  const [isOpen, setIsOpen] = useState(true);

  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const [state, setState] = useState("");
  const [stateId, setStateId] = useState([]);

  const [city, setcity] = useState("");
  const [cityId, setcityId] = useState([]);

  const GetAllStates = async () => {
    try {
      const res = await getStatesDropdown();
      if (res.success === true) {
        const value = res.data.map((state) => ({
          value: state.state,
          label: state.state,
        }));

        setStateId(value);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetAllCity = async (state) => {
    try {
      const res = await getcityDropdown(state);
      if (res.success === true) {
        const value = res.data.map((city) => ({
          value: city.city,
          label: city.city,
        }));
        setcityId(value);
        getUserListFromUsers(state, "");
      } else {
        getUserListFromUsers(state, "");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetAllStates();
  }, []);

  const columns = [
    {
      key: "sno",
      label: "S.No",
      _style: {
        width: "1%",
        backgroundColor: "rgb(225, 239, 250)",
        color: "#000",
        fontSize: "13px",
      },
      filter: false,
      sorter: false,
    },
    {
      key: "instituteName",
      label: "Institute Name",
      _style: {
        width: "5%",
        backgroundColor: "rgb(225, 239, 250)",
        color: "#000",
        fontSize: "13px",
      },
    },
    {
      key: "studentName",
      label: "Student Name",
      _style: {
        width: "5%",
        backgroundColor: "rgb(225, 239, 250)",
        color: "#000",
        fontSize: "13px",
      },
    },
    {
      key: "gender",
      label: "Gender",
      _style: {
        width: "5%",
        backgroundColor: "rgb(225, 239, 250)",
        color: "#000",
        fontSize: "13px",
      },
    },
    {
      key: "Action",
      label: "Action",
      _style: {
        width: "5%",
        backgroundColor: "rgb(225, 239, 250)",
        color: "#000",
        fontSize: "13px",
      },
    },
  ];

  const [usersData, setUsersData] = useState([]);
  const [usersDatas, setUsersDatas] = useState([]);

  const GetDashboardTableData = async (genderOption) => {
    try {
      const institutions = institutionName.map((x) => x.label);
      const body = {
        state: state.label,
        city: city.label,
        institutions: institutions,
        standard: standardId.value,
        subject: subjectId.value,
        gender: genderOption ? [genderOption.label] : [],
      };
      console.log(body, "123");

      const response = await getDashboardTable(body);

      if (response.success && response.data) {
        const tableData = response.data.map((item, index) => ({
          sno: index + 1,
          instituteName: item.schoolName,
          studentName: `${item.firstName} ${item.lastName}`,
          gender: item.gender,
          calculatedPercentage: item.calculatedPercentage,
          standardId: item.standard,
          mediumId: item.medium,
          subjectId: item.subject,
          userId: item.userId,
        }));
        setUsersDatas(tableData);
      } else {
        setUsersDatas([]);
      }
    } catch (error) {
      console.log(error);
      setUsersDatas([]);
    }
  };

  const [coverageSchoolName, setCoverageSchoolName] = useState("");
  const [coverageName, setCoverageName] = useState("");
  const [coverageUserId, setCoverageUserId] = useState("");

  const viewClick = (item) => {
    console.log(item, "7890");
    setCoverReportOpen(true);
    setShowCoverage(true);
    setStakeHolder(false);
    GetCoverageReport(item);
    setCoverageSchoolName(item.instituteName);
    setCoverageName(item.studentName);
    setCoverageUserId(item.userId);
  };

  const [coverageReport, setcoverageReport] = useState([]);
  const [booklistloading, setbooklistloading] = useState(true);

  const [coverReportOpen, setCoverReportOpen] = useState(false);
  const [coverUnitOpen, setCoverUnitOpen] = useState(false);
  const [coverSessionOpen, setCoverSessionOpen] = useState(false);
  const [viewedBookName, setviewedBookName] = useState("");
  const [viewedUnitName, setviewedUnitName] = useState("");
  const [coverageReportSession, setcoverageReportSession] = useState([]);

  const [bookunitSessions, setbookunitSessions] = useState([]);
  const [coverageReportUnit, setcoverageReportUnit] = useState([]);

  const coverageArr = [
    {
      label: "Sessions Covered",
      totalCount: "sessionCount",
      studentCount: "contentCompleted",
      type: "sessions",
      class: "coverthreejai111",
      translate: "sessioncovered",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: false,
    },
    {
      label: "Enhanced Content Viewed",
      totalCount: "totalAddContentCount",
      studentCount: "addContentCompleted",
      type: "addContent",
      class: "coverthreejai333",
      translate: "enhanceContent",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Concept Videos Viewed",
      totalCount: "totalConceptVideos",
      studentCount: "conceptVideosViewed",
      type: "concept",
      class: "coverthreejai444",
      translate: "conceptvideo",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Explanation Videos Viewed",
      totalCount: "totalTeachingVideos",
      studentCount: "teachingVideosViewed",
      type: "teaching",
      class: "coverthreejai555",
      translate: "teachingvideo",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "3D Videos Viewed",
      totalCount: "total3DVideo",
      studentCount: "threeDVideosViewed",
      type: "3dvideo",
      class: "coverthreejai111",
      translate: "threeDVideo",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "3D Models Viewed",
      totalCount: "total3DModel",
      studentCount: "threeDModelViewed",
      type: "3dmodel",
      class: "coverthreejai222",
      translate: "threeDModel",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "3D Activities Viewed",
      totalCount: "total3DActivity",
      studentCount: "threeDActivitiesViewed",
      type: "3dactivity",
      class: "coverthreejai333",
      translate: "threeDActivity",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "2D Animations Viewed",
      totalCount: "total2DAnimation",
      studentCount: "twoDAnimationViewed",
      type: "2danimation",
      class: "coverthreejai444",
      translate: "twoDAnimation",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Lesson Plan Viewed",
      totalCount: "totalLessonPlan",
      studentCount: "lessonPlanViewed",
      type: "lessonplan",
      class: "coverthreejai555",
      translate: "lessonPlan",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Virtual Lab Experiments Viewed",
      totalCount: "totalVirtualLab",
      studentCount: "virtualLabViewed",
      type: "virtuallab",
      class: "coverthreejai111",
      translate: "virtualLab",
      bookStatus: true,
      unitStatus: true,
      sessionStatus: true,
    },
    {
      label: "Notes Made",
      totalCount: "",
      studentCount: "notesCount",
      type: "notes",
      class: "",
      translate: "notes",
    },
    {
      label: "Book Marks Made",
      totalCount: "",
      studentCount: "bookmarkCount",
      type: "bookmarks",
      class: "",
      translate: "bookmarks",
    },
    {
      label: "Highlights Made",
      totalCount: "",
      studentCount: "highlighterCount",
      type: "highlights",
      class: "",
      translate: "highlights",
    },
    {
      label: "Hyperlink Made",
      totalCount: "",
      studentCount: "hyperlinkCount",
      type: "hyperlinks",
      class: "",
      translate: "hyperlinks",
    },
    {
      label: "Clarification Posted",
      totalCount: "",
      studentCount: "clarifyCount",
      type: "clarify",
      class: "",
      translate: "clarify",
    },
    {
      label: "Comments Posted",
      totalCount: "",
      studentCount: "commentCount",
      type: "comments",
      class: "",
      translate: "comments",
    },
  ];
  const [standard, setStandard] = useState([]);
  const [subject, setSubject] = useState([]);
  const [subjectId, setSubjectId] = useState("");
  const [standardId, setStandardId] = useState("");

  const getStandard = async (institutions) => {
    console.log(institutions, "222123");
    try {
      const bod = {
        institutions: institutions.map((x) => x.value),
      };
      const response = await getStandardbyInstitutionName(bod);
      if (response.success === true) {
        const data = response.data.map((x) => ({
          value: x._id,
          label: x.variableName,
          mediumId: x.mediumId,
        }));
        setStandard(data);
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetCoverageReport = async (item) => {
    try {
      setbooklistloading(true);
      const value = [];
      const CountBody = {
        bookId: item?.subjectId,
        studentId: item?.userId,
        refInstID: "789",
        refMediumID: item?.mediumId ? item?.mediumId : 1,
        refStandardID: item?.standardId,
        refSubjectID: item?.subjectId,
      };
      const response = await GetBookCountforAll(CountBody);
      if (response?.success) {
        let resBooks = {
          bookId: item?.subjectId,
          bookName: subjectId?.label,
          className: standardId?.label?.split("-")[0]?.trim(),
          booksProgress: response?.value,
        };

        value.push(resBooks);
        console.log(value, "setcoverageReport");
        setcoverageReport((prev) => [...prev, resBooks]);
        setbooklistloading(false);
      } else {
        setcoverageReport([]);
        setbooklistloading(false);
        toast.error(response.error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const FetchAllSessionAnalytics = async (bookId, dataList) => {
    setcoverageReportSession([]);
    setbooklistloading(true);
    if (dataList?.length !== 0) {
      const value = [];
      (async () => {
        for (let as = 0; as < dataList?.length; as++) {
          let response;
          const CountBody = {
            sessionId: dataList[as]?.SessionId,
            studentId: coverageUserId,
            refInstID: "789",
            refMediumID: standard.mediumId ? standard.mediumId : 1,
            refStandardID: standard.value ? standard.value : "",
            refSubjectID: bookId,
          };
          response = await GetSessionCountforAll(CountBody);

          if (response?.success) {
            let resBooks = {
              bookId: bookId,
              sessionId: dataList[as]?.SessionId,
              SessionName: dataList[as]?.SessionName,
              booksProgress: response?.value,
            };
            console.log(resBooks, "setcoverageReport");
            value.push(resBooks);
            console.log(value, "setcoverageReport");
            setcoverageReportSession((prev) => [...prev, resBooks]);
            setbooklistloading(false);
          }
        }
      })();
    } else {
      setcoverageReportSession([]);
      setbooklistloading(false);
    }
  };

  const FetchAllUnitAnalytics = async (bookId, dataList) => {
    setcoverageReportUnit([]);
    setbooklistloading(true);
    if (dataList?.length !== 0) {
      const value = [];
      (async () => {
        for (let as = 0; as < dataList?.length; as++) {
          console.log(dataList[as], "setcoverageReport");

          if (as > 0) {
            let response;
            const CountBody = {
              unitId: dataList[as]?.UnitId,
              studentId: coverageUserId,
              refInstID: "789",
              refMediumID: standard.mediumId ? standard.mediumId : 1,
              refStandardID: standard.value ? standard.value : "",
              refSubjectID: bookId,
            };
            response = await GetUnitCountforAll(CountBody);

            if (response?.success) {
              let resBooks = {
                bookId: bookId,
                unitId: dataList[as]?.UnitId,
                unitName: dataList[as]?.UnitName,
                booksProgress: response?.value,
              };
              console.log(resBooks, "setcoverageReport");
              value.push(resBooks);
              console.log(value, "setcoverageReport");
              setcoverageReportUnit((prev) => [...prev, resBooks]);
              setbooklistloading(false);
            }
          }
        }
      })();
    } else {
      setcoverageReportUnit([]);
      setbooklistloading(false);
    }
  };

  const FetchAllUnitsSessions = async (bookId) => {
    let response = await GetBookUnitSessions(bookId);
    if (response?.success && response?.variable?.length > 0) {
      setbookunitSessions(response?.variable[0]?.Units);
      FetchAllUnitAnalytics(bookId, response?.variable[0]?.Units);
    }
  };

  const [institutionName, setInstitutionName] = useState([]);
  const [institutionNameId, setInstitutionNameId] = useState([]);
  const GetInstitutionName = async (state, city) => {
    try {
      const res = await getInstitutionNameDashboard(state, city);
      if (res.success === true) {
        const data = res.data.map((x) => ({
          value: x.school,
          label: x.school,
        }));
        setInstitutionNameId(data);
        getUserListFromUsers(state, city);
      } else {
        toast.error(res.error);
        setInstitutionNameId([]);
        getUserListFromUsers(state, city);
      }
    } catch (error) {
      console.error("Error fetching institution name:", error);
    }
  };

  const getSubjectDashboard = async (standard) => {
    try {
      const res = await getSubjectfordashboard(standard);
      if (res.success === true) {
        const data = res.data.map((x) => ({
          value: x.yearId,
          label: x.variableName,
          id: x._id,
        }));
        setSubject(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [selectedGender, setSelectedGender] = useState("");

  const [showStakeHolder, setStakeHolder] = useState(true);
  const [showCoverage, setShowCoverage] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    // const currentVersion = localStorage.getItem("app_version");
    localStorage.removeItem("userID");
    localStorage.removeItem("userCode");
    localStorage.removeItem("username");
    localStorage.removeItem("encryptedMedium");
    localStorage.removeItem("encryptedSubjects");
    localStorage.removeItem("encryptedStandard");
    localStorage.removeItem("token");
    localStorage.removeItem("userData");
    localStorage.removeItem("IsUserAuth");
    localStorage.removeItem("userType");
    localStorage.removeItem("username");
    // localStorage.clear();
    // localStorage.setItem("app_version", currentVersion);
    navigate("/superad-login");
  };

  const getUserListFromUsers = async (state, city) => {
    try {
      let response;
      response = await GetUserListDashboard(state, city);
      if (response.success && response.data) {
        const tableData = response.data.map((item, index) => ({
          sno: index + 1,
          instituteName: item.schoolName,
          studentName: `${item.firstName} ${item.lastName}`,
          gender: item.gender,
          calculatedPercentage: item.calculatedPercentage,
          standardId: item.standard,
          mediumId: item.medium,
          subjectId: item.subject,
          userId: item.userId,
          Action: "-",
        }));
        setUsersData(tableData);
      } else {
        setUsersData([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [isDownloading, setIsDownloading] = useState(false);

  const DownloadExcelReport = async () => {
    try {
      setIsDownloading(true);
      const response = await reportGenerate();
      if (response.success === true) {
        if (response && response.data && Array.isArray(response.data)) {
          const filteredData = response.data.filter(
            (user) => user.role !== "Admin" && user.role !== "SuperAdmin"
          );

          const headers = [
            "firstName",
            "lastName",
            "schoolName",
            "mobileNo",
            "gender",
            "role",
            "email",
            "createdAt",
            "city",
            "state",
            "area",
            "class",
            "isFeedbackSubmitted",
          ];

          // Display headers with custom names
          const displayHeaders = [
            "firstName",
            "lastName",
            "schoolName",
            "mobileNo",
            "gender",
            "role",
            "email",
            "createdAt",
            "city",
            "state",
            "area",
            "class",
            "Feedback Submitted",
          ];

          const formattedData = [
            displayHeaders, // Use display headers instead
            ...filteredData.map((item) =>
              headers.map((h) => {
                if (h === "createdAt" && item[h]) {
                  return moment(item[h]).format("DD/MMM/YYYY");
                }
                // Handle isFeedbackSubmitted conversion
                if (h === "isFeedbackSubmitted") {
                  return item[h] === true ? "Yes" : "No";
                }
                return item[h] || "";
              })
            ),
          ];

          const worksheet = XLSX.utils.aoa_to_sheet(formattedData);

          displayHeaders.forEach((header, index) => {
            // Use displayHeaders here too
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
            if (!worksheet[cellAddress]) return;
            worksheet[cellAddress].s = {
              font: { bold: true, color: { rgb: "000000" } },
              alignment: { horizontal: "center", vertical: "center" },
            };
          });

          worksheet["!cols"] = displayHeaders.map((header) => ({
            wch: header.length + 10,
          }));

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
          XLSX.writeFile(workbook, "User_Report.xlsx");
        } else {
          console.error("Invalid data structure from API");
        }
      } else {
        toast.error(response.error || "Failed to generate report");
      }
    } catch (error) {
      console.error("Error while generating report:", error);
      toast.error("Something went wrong while generating report!");
    } finally {
      setIsDownloading(false);
    }
  };

  const [isDownloadingTableData, setIsDownloadingTableData] = useState(false);

  const DownloadExcelReportTableData = async (state, city) => {
    try {
      setIsDownloadingTableData(true);
      const response = await GetUserListDashboard(state, city);
      if (response.success === true) {
        if (response && response.data && Array.isArray(response.data)) {
          const filteredData = response.data.filter(
            (user) => user.role !== "Admin" && user.role !== "SuperAdmin"
          );

          const headers = [
            "firstName",
            "lastName",
            "schoolName",
            "mobileNo",
            "gender",
            "role",
            "email",
            "createdAt",
            "city",
            "state",
            "area",
            "class",
            "isFeedbackSubmitted",
          ];

          // Display headers with custom names
          const displayHeaders = [
            "firstName",
            "lastName",
            "schoolName",
            "mobileNo",
            "gender",
            "role",
            "email",
            "createdAt",
            "city",
            "state",
            "area",
            "class",
            "Feedback Submitted",
          ];

          const formattedData = [
            displayHeaders, // Use display headers
            ...filteredData.map((item) =>
              headers.map((h) => {
                if (h === "createdAt" && item[h]) {
                  return moment(item[h]).format("DD/MMM/YYYY");
                }
                // Handle isFeedbackSubmitted conversion
                if (h === "isFeedbackSubmitted") {
                  return item[h] === true ? "Yes" : "No";
                }
                return item[h] || "";
              })
            ),
          ];

          const worksheet = XLSX.utils.aoa_to_sheet(formattedData);

          displayHeaders.forEach((header, index) => {
            // Use displayHeaders
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
            if (!worksheet[cellAddress]) return;
            worksheet[cellAddress].s = {
              font: { bold: true, color: { rgb: "000000" } },
              alignment: { horizontal: "center", vertical: "center" },
            };
          });

          worksheet["!cols"] = displayHeaders.map((header) => ({
            wch: header.length + 10,
          }));

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
          XLSX.writeFile(
            workbook,
            `${city === "" ? state : city}_User_Report.xlsx`
          );
        } else {
          console.error("Invalid data structure from API");
        }
      } else {
        toast.error(response.error || "Failed to generate report");
      }
    } catch (error) {
      console.error("Error while generating report:", error);
      toast.error("Something went wrong while generating report!");
    } finally {
      setIsDownloadingTableData(false);
    }
  };

  const UserName = localStorage.getItem("username");
  const UserProfileType = JSON.parse(localStorage.getItem("userType"));

  const [feedBackFormOpen, setFeedBackFormOpen] = useState(false);

  const feedbackClick = () => {
    setShowMainContent(false);
    setShowSidePage(false);
    setFeedBackFormOpen(true);
  };

  const backClick = () => {
    setShowMainContent(true);
    setShowSidePage(false);
    setFeedBackFormOpen(false);
  };

  const [usersDataFeedBack, setUsersDataFeedBack] = useState([]);
  const [FeedBackcolumns, setFeedBackColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rawResponseData, setRawResponseData] = useState(null);

  const [userTypeId, setUserTypeId] = useState("");
  const [classId, setClassId] = useState("");

  const userTypeOptions = [
    { value: "student", label: "Student" },
    { value: "teacher", label: "Teacher" },
  ];

  const classOptions = [
    { value: 1, label: "Class 1" },
    { value: 6, label: "Class 6" },
    { value: 12, label: "Class 12" },
  ];

  const generateFeedbackColumns = (questions) => {
    const baseColumns = [
      {
        key: "sno",
        label: "S.No",
        _style: {
          width: "3%",
          backgroundColor: "rgb(225, 239, 250)",
          color: "#000",
          fontSize: "13px",
        },
        filter: false,
        sorter: false,
      },
      {
        key: "class",
        label: "Class",
        _style: {
          width: "8%",
          backgroundColor: "rgb(225, 239, 250)",
          color: "#000",
          fontSize: "13px",
        },
        sorter: false,
      },
      {
        key: "question",
        label: "Question",
        _style: {
          width: "20%",
          backgroundColor: "rgb(225, 239, 250)",
          color: "#000",
          fontSize: "13px",
        },
        sorter: false,
      },
    ];

    const users = questions[0]?.responses || [];

    const userColumns = users.map((user, index) => ({
      key: `user_${index}`,
      label: `${user.username} - ${user.mobileNo}`,
      _style: {
        width: "auto",
        backgroundColor: "rgb(225, 239, 250)",
        color: "#000",
        fontSize: "13px",
      },
      sorter: false,
    }));

    return [...baseColumns, ...userColumns];
  };

  const GetFeedbackReport = async (
    classIdValue,
    userTypeIdValue,
    classIdLabel
  ) => {
    try {
      setLoading(true);

      let response = await getFeedbackReport(classIdValue, userTypeIdValue);

      if (response.success && response.data && response.data.length > 0) {
        setRawResponseData(response.data);

        const tableData = response.data.map((questionData, qIndex) => {
          const rowData = {
            sno: qIndex + 1,
            class: classIdLabel,
            question: questionData.question,
          };

          questionData.responses.forEach((responseItem, userIndex) => {
            rowData[`user_${userIndex}`] = responseItem.answer;
          });

          return rowData;
        });

        const columns = generateFeedbackColumns(response.data);

        setFeedBackColumns(columns);
        setUsersDataFeedBack(tableData);
      } else {
        setRawResponseData(null);
        setFeedBackColumns([]);
        setUsersDataFeedBack([]);
      }
    } catch (err) {
      console.log(err);
      setRawResponseData(null);
      setFeedBackColumns([]);
      setUsersDataFeedBack([]);
    } finally {
      setLoading(false);
    }
  };

  const downloadExcelReport = () => {
    if (!rawResponseData || rawResponseData.length === 0) {
      alert("No data available to download!");
      return;
    }

    try {
      const excelData = [];
      const allUsers = rawResponseData[0]?.responses || [];

      const headerRow = ["S.No", "Class", "Question"];
      allUsers.forEach((user) => {
        headerRow.push(`${user.username} - ${user.mobileNo}`); 
      });
      excelData.push(headerRow);

      rawResponseData.forEach((questionData, index) => {
        const row = [index + 1, classId.label, questionData.question];

        questionData.responses.forEach((response) => {
          row.push(response.answer);
        });

        excelData.push(row);
      });

      const worksheet = XLSX.utils.aoa_to_sheet(excelData);

      const columnWidths = [
        { wch: 5 },
        { wch: 12 },
        { wch: 40 },
        ...allUsers.map(() => ({ wch: 20 })),
      ];
      worksheet["!cols"] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Feedback Report");

      const filename = `Feedback_Report_${classId.label}_${
        userTypeId.label
      }_${new Date().toLocaleDateString().replace(/\//g, "-")}.xlsx`;

      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Error downloading report:", error);
      alert("Error downloading report. Please try again.");
    }
  };

  return (
    <div className="p-2" style={{ background: "#f5f5f5" }}>
      <div
        style={{
          background: "#fff",
          borderRadius: "10px",
          boxShadow: "0 .125rem .25rem rgba(0,0,0,.075)",
        }}
        className="d-flex justify-content-between align-items-center px-4 py-2"
      >
        <div>
          <div className="ncert_white_Logo1">
            <img src={header_Embelem} className="w-100" alt="logo" />
          </div>
        </div>

        <div className="d-flex align-items-center gap-3">
          {feedBackFormOpen ? (
            <div className="feedback-btn downReport " onClick={backClick}>
              Back to Dashboard
            </div>
          ) : (
            <div className="feedback-btn downReport " onClick={feedbackClick}>
              Feedback Report
            </div>
          )}

          <div>
            <img
              src="https://cdn.katbook.com/assets/sites/ncert/754664531585798144_ProfileLogo.png"
              alt="profile"
              style={{ width: "38px", height: "38px", borderRadius: "50%" }}
            />
          </div>

          <div
            className="d-flex gap-2 align-items-center"
            onClick={handleclick}
            style={{ cursor: "pointer" }}
          >
            <div className="d-flex flex-column text-end">
              <div className="text">{UserName}</div>
              <div className="section">{UserProfileType.usertype}</div>
            </div>
            <div className="pt-0">
              <FaChevronDown size={12} />
            </div>
          </div>
        </div>
      </div>

      {dropdown && (
        <div className="d-flex flex-column gap-2 backgroundeffect1 ">
          <div className="account"> Account</div>
          <div className="sections  px-3 py-1">
            <IoPersonCircle size={20} />
            &nbsp;{UserName}
          </div>
          <div className="sections px-3 py-1" onClick={handleLogout}>
            <MdOutlineLogout size={20} />
            &nbsp; Log Out
          </div>
        </div>
      )}

      {showMainContent && (
        <div className="py-2">
          {/* <div className="row d-flex align-items-center">
          <div className="col-md-3">
            <Input
              label={"Select State"}
              Selectplaceholder={"Select"}
              labelClassName={"Select_label"}
              className={"input-size p-2"}
              isDropdown
            />
          </div>
          <div className="col-md-3">
            <Input
              label={"Select District"}
              Selectplaceholder={"Select"}
              labelClassName={"Select_label"}
              className={"input-size p-2"}
              isDropdown
            />
          </div>
          <div className="col-md-3">
            <Input
              label={"Select City"}
              Selectplaceholder={"Select"}
              labelClassName={"Select_label"}
              className={"input-size p-2"}
              isDropdown
            />
          </div>
          <div className="col-md-3">
            <Input
              label={"Select Area"}
              Selectplaceholder={"Select"}
              labelClassName={"Select_label"}
              className={"input-size p-2"}
              isDropdown
            />
          </div>
        </div> */}

          <div className="row d-flex align-items-center pt-0">
            <div className="col-md-6">
              <div className="back-admin d-flex align-items-center justify-content-between gap-3">
                <div className="border-right-amtT d-flex align-items-center gap-3">
                  {/* <div> */}
                  <img src={img1} alt="" width={"20%"} />
                  {/* </div> */}
                  <div className="d-flex flex-column align-items-center">
                    <div className="amt_font">
                      {userCount?.male + userCount?.female}
                    </div>
                    <div className="amt_sub_font">Total Student Enrolled</div>
                  </div>
                </div>
                <div className="border-right-amtB">
                  <div className="d-flex flex-column padd_amt_font">
                    <div className="amt_font">{userCount?.male}</div>
                    <div className="amt_sub_font">Boys</div>
                  </div>
                </div>
                <div className="d-flex flex-column padd_amt_font">
                  <div className="amt_font">{userCount?.female}</div>
                  <div className="amt_sub_font">Girls</div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="back-admin d-flex align-items-center justify-content-center gap-3">
                <div className="d-flex align-items-center justify-content-center gap-4 ">
                  {/* <div> */}
                  <img src={img2} alt="" width={"30%"} />
                  <div className="d-flex flex-column align-items-center">
                    <div className="amt_font">{userCount?.parents}</div>
                    <div className="amt_sub_font">Parents</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="back-admin d-flex align-items-center justify-content-center gap-3">
                <div className="d-flex align-items-center justify-content-center gap-4">
                  {/* <div> */}
                  <img src={img3} alt="" width={"30%"} />
                  {/* </div> */}
                  <div className="d-flex flex-column align-items-center">
                    <div className="amt_font">{userCount?.teachers}</div>
                    <div className="amt_sub_font">Total Teachers</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-2">
            {/* d-flex align-items-center gap-3  */}

            <div className="col-md-4 mapPadout">
              <div className="back-admin">
                <div className="d-flex align-items-start justify-content-between">
                  <div className="coun_font">
                    Stakeholder Enrollment of{" "}
                    {selectedState ? selectedState : "India"}
                  </div>
                  <div className="wid-map">
                    <Input
                      label={"State / UT"}
                      isDropdown
                      options={stateCountList
                        .filter((state) => state._id !== null)
                        .map((state) => ({
                          value: state._id,
                          label: state._id,
                        }))}
                      value={
                        stateCountList
                          .filter((state) => state._id !== null)
                          .map((state) => ({
                            value: state._id,
                            label: state._id,
                          }))
                          .find((opt) => opt.value === selectedState) || null
                      }
                      onChange={handleDropdownChange}
                      placeholder={"Select State / UT"}
                      isClearable={true}
                    />
                  </div>
                </div>

                {/* Rest of your component remains the same */}
                <div
                  style={{
                    textAlign: "center",
                    maxWidth: "385px",
                    margin: "0 auto",
                  }}
                >
                  <div style={{ marginTop: "20px" }}>
                    <SVGMap
                      map={filteredMap}
                      // locationClassName={getLocationClass}
                    />
                  </div>

                  <div className="coun_font">
                    Total Population of{" "}
                    {selectedState ? selectedState : "State / UT"}:{" "}
                    {selectedState
                      ? (
                          stateCountList.find(
                            (state) =>
                              state._id &&
                              state._id.toLowerCase() ===
                                selectedState.toLowerCase()
                          )?.totalUsers || 0
                        ).toLocaleString()
                      : stateCountList
                          .filter((state) => state._id !== null)
                          .reduce(
                            (total, state) => total + (state.totalUsers || 0),
                            0
                          )
                          .toLocaleString()}
                  </div>
                </div>

                <div className="d-flex align-items-start justify-content-center pt-2 gap-4">
                  <div className="d-flex flex-column gap-1">
                    <div className="stu_Tot_font">
                      Total Students:{" "}
                      <span className="count_font_bl">
                        {selectedState
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState.toLowerCase()
                              )?.totalStudents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.totalStudents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                    <div className="stu_Tot_font">
                      Boys:{" "}
                      <span className="count_font_bl">
                        {selectedState
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState.toLowerCase()
                              )?.maleStudents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.maleStudents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                    <div className="stu_Tot_font">
                      Girls:{" "}
                      <span className="count_font_bl">
                        {selectedState
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState.toLowerCase()
                              )?.femaleStudents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.femaleStudents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-1">
                    <div className="stu_Tot_font">
                      Total Parents:{" "}
                      <span className="count_font_bl">
                        {selectedState
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState.toLowerCase()
                              )?.totalParents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.totalParents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                    <div className="stu_Tot_font">
                      Total Teachers:{" "}
                      <span className="count_font_bl">
                        {selectedState
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState.toLowerCase()
                              )?.totalTeachers || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.totalTeachers || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-8 d-flex flex-column gap-2">
              <div className="">
                <div className="d-flex flex-column gap-3 back-admin">
                  <div className="d-flex align-items-center justify-content-between gap-2 coun_font">
                    <div>
                      <span>Stakeholder’s Summary of Top Cities</span>
                      <span>
                        <RiArrowRightDoubleFill
                          size={23}
                          className="pointer"
                          onClick={() => {
                            setShowMainContent(false);
                            setShowSidePage(true);
                          }}
                        />
                      </span>
                    </div>

                    <div
                      className={`downReport ${
                        isDownloading ? "disabled" : ""
                      }`}
                      onClick={() => {
                        if (!isDownloading) DownloadExcelReport();
                      }}
                      style={{
                        opacity: isDownloading ? 0.6 : 1,
                        pointerEvents: isDownloading ? "none" : "auto",
                        cursor: isDownloading ? "not-allowed" : "pointer",
                      }}
                    >
                      {isDownloading ? "Generating..." : "Download Report"}
                    </div>
                  </div>

                  <div className="super-overf">
                    <div className="d-flex align-items-center gap-3">
                      {topCites
                        .filter((city) => city._id !== null)
                        .map((city, index) => {
                          const colorClass =
                            index % 3 === 0
                              ? "blu_admin"
                              : index % 3 === 1
                              ? "oran_admin"
                              : "gree_admin";
                          const padClass =
                            index % 3 === 0
                              ? "pad_bot_stak1"
                              : index % 3 === 1
                              ? "pad_bot_stak2"
                              : "pad_bot_stak3";
                          const countFontClass =
                            index % 3 === 0
                              ? "count_font_bl"
                              : index % 3 === 1
                              ? "count_font_or"
                              : "count_font_gr";

                          return (
                            <div
                              key={city._id || `city-${index}`}
                              className={`d-flex flex-column gap-2 ${colorClass}`}
                            >
                              <div
                                className={`${padClass} d-flex align-items-center justify-content-between`}
                              >
                                <span className="coun_font">
                                  {city._id || "Unknown City"}
                                </span>
                                {/* <span>
                                <BsArrowRightCircle size={20} />
                              </span> */}
                              </div>
                              <div className="d-flex flex-column gap-2">
                                <div className="d-flex flex-column">
                                  <div className="d-flex align-items-center gap-3 widthMax">
                                    <span className="stu_Tot_font">
                                      Total Students:{" "}
                                    </span>
                                    <span className={countFontClass}>
                                      {city.totalStudents?.toLocaleString() ||
                                        0}
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <span className="stu_Tot_font_sub">
                                      Boys:{" "}
                                    </span>
                                    <span className={countFontClass}>
                                      {city.maleStudents?.toLocaleString() || 0}
                                    </span>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-between">
                                    <span className="stu_Tot_font_sub">
                                      Girls:{" "}
                                    </span>
                                    <span className={countFontClass}>
                                      {city.femaleStudents?.toLocaleString() ||
                                        0}
                                    </span>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                  <span className="stu_Tot_font">
                                    Total Parents:{" "}
                                  </span>
                                  <span className={countFontClass}>
                                    {city.totalParents?.toLocaleString() || 0}
                                  </span>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                  <span className="stu_Tot_font">
                                    Total teachers:{" "}
                                  </span>
                                  <span className={countFontClass}>
                                    {city.totalTeachers?.toLocaleString() || 0}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-100">
                <div className="heigth_chart d-flex flex-column gap-3 back-admin">
                  <div className="d-flex align-items-center gap-2 coun_font">
                    <span>Summary of States / UT</span>
                    <span>
                      <RiArrowRightDoubleFill
                        size={23}
                        className="pointer"
                        onClick={() => {
                          setShowMainContent(false);
                          setShowSidePage(true);
                        }}
                      />
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2 justify-content-center">
                    <div>
                      <PieChart
                        data={{
                          labels: stateCountList
                            .filter((state) => state._id !== null)
                            .map((state) => state._id),
                          datasets: [
                            {
                              data: stateCountList
                                .filter((state) => state._id !== null)
                                .map((state) => state.totalUsers),
                              backgroundColor: [
                                "rgba(255, 99, 132, 0.6)",
                                "rgba(54, 162, 235, 0.6)",
                                "rgba(255, 206, 86, 0.6)",
                                "rgba(75, 192, 192, 0.6)",
                                "rgba(153, 102, 255, 0.6)",
                                "rgba(255, 159, 64, 0.6)",
                                "rgba(199, 199, 199, 0.6)",
                                "rgba(83, 102, 255, 0.6)",
                                "rgba(40, 159, 64, 0.6)",
                                "rgba(210, 99, 132, 0.6)",
                                "rgba(20, 162, 235, 0.6)",
                              ],
                              borderColor: [
                                "rgba(255, 99, 132, 1)",
                                "rgba(54, 162, 235, 1)",
                                "rgba(255, 206, 86, 1)",
                                "rgba(75, 192, 192, 1)",
                                "rgba(153, 102, 255, 1)",
                                "rgba(255, 159, 64, 1)",
                                "rgba(199, 199, 199, 1)",
                                "rgba(83, 102, 255, 1)",
                                "rgba(40, 159, 64, 1)",
                                "rgba(210, 99, 132, 1)",
                                "rgba(20, 162, 235, 1)",
                              ],
                              borderWidth: 1,
                            },
                          ],
                        }}
                        styleName={"height_pie"}
                        options={options}
                      />
                    </div>

                    <div className="firstPiechartTable">
                      <table
                        style={{
                          width: "100%",
                          textAlign: "center",
                          border: "1px solid",
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <th className="super-table-head">State</th>
                            <th className="super-table-head">Students</th>
                            <th className="super-table-head">Boys</th>
                            <th className="super-table-head">Girls</th>
                            <th className="super-table-head">Teachers</th>
                            <th className="super-table-head">Parents</th>
                          </tr>
                        </thead>
                        <tbody>
                          {stateCountList
                            .filter((state) => state._id !== null)
                            .map((state, index) => (
                              <tr key={state._id || `state-${index}`}>
                                <td
                                  className="super-table-row"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "5px",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      borderRadius: "50%",
                                      backgroundColor:
                                        colors[index] || "transparent",
                                      display: "inline-block",
                                    }}
                                  ></span>
                                  {state._id || "Unknown"}
                                </td>

                                <td className="super-table-row">
                                  {state.totalStudents || 0}
                                </td>
                                <td className="super-table-row">
                                  {state.maleStudents || 0}
                                </td>
                                <td className="super-table-row">
                                  {state.femaleStudents || 0}
                                </td>
                                <td className="super-table-row">
                                  {state.totalTeachers || 0}
                                </td>
                                <td className="super-table-row">
                                  {state.totalParents || 0}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="row pt-2">

            <div className="col-md-5 mapPadout">
              <div className="back-admin">
                <div className="d-flex align-items-start justify-content-between">
                  <div className="coun_font">Stakeholder Coverage Report</div>
                  <div className="wid-map">
                    <Input
                      label={"State / UT"}
                      isDropdown
                      options={stateCountList
                        .filter((state) => state._id !== null)
                        .map((state) => ({
                          value: state._id,
                          label: state._id,
                        }))}
                      value={
                        stateCountList
                          .filter((state) => state._id !== null)
                          .map((state) => ({
                            value: state._id,
                            label: state._id,
                          }))
                          .find((opt) => opt.value === selectedState1) || null
                      }
                      onChange={handleDropdownChange1}
                      placeholder={"Select State / UT"}
                      isClearable={true}
                    />
                  </div>
                </div>

                <div
                  // className={`map-container ${selectedState ? "zoomed" : ""}`}
                  style={{
                    textAlign: "center",
                    maxWidth: "385px",
                    margin: "0 auto",
                  }}
                >
                  <div style={{ marginTop: "20px" }}>
                    <SVGMap
                      map={filteredMap1}
                      // locationClassName={getLocationClass}
                    />
                  </div>

                  <div className="coun_font">
                    Total Population of{" "}
                    {selectedState1 ? selectedState1 : "State / UT"}:{" "}
                    {selectedState1
                      ? (
                          stateCountList.find(
                            (state) =>
                              state._id &&
                              state._id.toLowerCase() ===
                                selectedState1.toLowerCase()
                          )?.totalUsers || 0
                        ).toLocaleString()
                      : stateCountList
                          .filter((state) => state._id !== null)
                          .reduce(
                            (total, state) => total + (state.totalUsers || 0),
                            0
                          )
                          .toLocaleString()}
                  </div>
                </div>

                <div className="d-flex align-items-start justify-content-center pt-2 gap-4">
                  <div className="d-flex flex-column gap-1">
                    <div className="stu_Tot_font">
                      Total Students:{" "}
                      <span className="count_font_bl">
                        {selectedState1
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState1.toLowerCase()
                              )?.totalStudents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.totalStudents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                    <div className="stu_Tot_font">
                      Boys:{" "}
                      <span className="count_font_bl">
                        {selectedState1
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState1.toLowerCase()
                              )?.maleStudents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.maleStudents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                    <div className="stu_Tot_font">
                      Girls:{" "}
                      <span className="count_font_bl">
                        {selectedState1
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState1.toLowerCase()
                              )?.femaleStudents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.femaleStudents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-1">
                    <div className="stu_Tot_font">
                      Total Parents:{" "}
                      <span className="count_font_bl">
                        {selectedState1
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState1.toLowerCase()
                              )?.totalParents || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.totalParents || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                    <div className="stu_Tot_font">
                      Total Teachers:{" "}
                      <span className="count_font_bl">
                        {selectedState1
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState1.toLowerCase()
                              )?.totalTeachers || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.totalTeachers || 0),
                                0
                              )
                              .toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-7 d-flex flex-column gap-2">
              <div className="">
                <div className="d-flex flex-column gap-3 back-admin">
                  <div className="d-flex align-items-center gap-2 coun_font">
                    <span>Stakeholder’s Summary of Top Cities</span>
                    <span>
                      <RiArrowRightDoubleFill size={23} className="pointer" />
                    </span>
                  </div>

                  <div className="super-overf">
                    <div className="d-flex align-items-center gap-3">
                      <div className="d-flex flex-column gap-2 blu_admin">
                        <div className="pad_bot_stak1 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Delhi</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_bl d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 oran_admin">
                        <div className="pad_bot_stak2 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Mumbai</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_or d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 gree_admin">
                        <div className="pad_bot_stak3 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Chennai</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_gr d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 oran_admin">
                        <div className="pad_bot_stak2 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Goa</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_or d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 blu_admin">
                        <div className="pad_bot_stak1 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Himachal Pradesh</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-5">
                              <div className="cov-font-chart">Standard</div>
                              <div className="cov-font-chart text-center">
                                Coverage Report
                              </div>
                            </div>

                            <div className="standard-overf">
                              <div className="d-flex align-items-center gap-5 justify-content-around">
                                <div className="stan_font d-flex flex-column">
                                  <div>I</div>
                                  <div>II</div>
                                  <div>III</div>
                                  <div>IV</div>
                                  <div>V</div>
                                  <div>VI</div>
                                  <div>VII</div>
                                </div>
                                <div className="count_font_bl d-flex flex-column">
                                  <div>50%</div>
                                  <div>55%</div>
                                  <div>40%</div>
                                  <div>60%</div>
                                  <div>65%</div>
                                  <div>70%</div>
                                  <div>51%</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-100">
                <div className="heigth_chart d-flex flex-column gap-0 back-admin">
                  <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center gap-2 coun_font">
                      <span>Stakeholder Coverage Report of States / UT</span>
                      <span>
                        <RiArrowRightDoubleFill
                          size={23}
                          className="pointer"
                          onClick={() => {
                            setShowMainContent(false);
                            setShowSidePage(true);
                          }}
                        />
                      </span>
                    </div>

                    <div className="w-25">
                      <Input
                        placeholder={"Select Class"}
                        isDropdown
                        adminlabel={true}
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2 justify-content-center">
                    <div>
                      <PieChart
                        data={data}
                        options={options}
                        styleName={"height_pie"}
                      />
                    </div>

                    <div>
                      <table
                        style={{
                          width: "100%",
                          textAlign: "center",
                          border: "1px solid",
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <th className="super-table-head">State</th>
                            <th className="super-table-head">Students</th>
                            <th className="super-table-head">Boys</th>
                            <th className="super-table-head">Girls</th>
                            <th className="super-table-head">Teachers</th>
                            <th className="super-table-head">Parents</th>
                          </tr>
                        </thead>
                        <tbody>
                          {studentsdata.map((row, index) => (
                            <tr key={index}>
                              <td className="super-table-name">{row.state}</td>
                              <td className="super-table-row">
                                {row.students}
                              </td>
                              <td className="super-table-row">{row.boys}</td>
                              <td className="super-table-row">{row.girls}</td>
                              <td className="super-table-row">
                                {row.teachers}
                              </td>
                              <td className="super-table-row">{row.parents}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      )}

      {showSidePage && (
        <div className="d-flex align-items-start" style={{ width: "100%" }}>
          {/* Left Side */}
          <div
            className="pt-2"
            style={{
              width: isOpen ? "69%" : "100%",
              transition: "width 0.3s ease",
              background: "#f5f5f5",
            }}
          >
            <div className="border-rad d-flex align-items-center justify-content-between p-2 bg-white">
              <div className="d-flex align-items-center gap-2">
                <IoArrowUndoCircle
                  size={30}
                  className="back-arrow"
                  onClick={() => {
                    setShowMainContent(true);
                    setShowSidePage(false);
                    setState("");
                    setcity("");
                    setInstitutionName("");
                    setStandardId("");
                    setSubjectId("");
                    setSelectedGender("");
                    setUsersData([]);
                    setUsersDatas([]);
                  }}
                />
                <div className="coun_font">
                  Stakeholder Coverage Report of States / UT
                </div>
              </div>
              <div>
                <LuPanelRightClose
                  size={23}
                  onClick={toggleDrawer} // toggle 70/100
                  className="pointer"
                />
              </div>
            </div>

            <div className="p-2 height-stake">
              <div className="row">
                <div className="col-md-4">
                  <Input
                    label={"State / UT"}
                    Selectplaceholder={"Select State / UT"}
                    isDropdown
                    labelClassName={"Label_FontM"}
                    value={state}
                    options={stateId}
                    onChange={(e) => {
                      setState(e);
                      GetAllCity(e.value);
                      setcity("");
                      setInstitutionName("");
                      setStandardId("");
                      setSubjectId("");
                      setSelectedGender("");
                      setShowCoverage(false);
                      setStakeHolder(true);
                      setUsersDatas([]);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    label={"City"}
                    Selectplaceholder={"Select City"}
                    isDropdown
                    value={city}
                    labelClassName={"Label_FontM"}
                    options={cityId}
                    isDisabled={!state}
                    onChange={(e) => {
                      setcity(e);
                      setInstitutionName([]);
                      setStandardId("");
                      setSubjectId("");
                      setInstitutionNameId([]);
                      setSelectedGender("");
                      setShowCoverage(false);
                      setStakeHolder(true);
                      GetInstitutionName(state.label, e.label);
                      setUsersDatas([]);
                    }}
                  />
                </div>
                <div className="col-md-4 position-relative">
                  <Input
                    label={"Institution Name"}
                    Selectplaceholder={"Select Institution Name"}
                    value={institutionName}
                    options={institutionNameId}
                    labelClassName={"Label_FontM"}
                    isDisabled={!city}
                    onChange={(e) => {
                      setInstitutionName(e);
                      setStandardId("");
                      setSubjectId("");
                      setSelectedGender("");
                      setShowCoverage(false);
                      setStakeHolder(true);
                      getStandard(e);
                      setUsersDatas([]);
                    }}
                    isDropdownSelectAll
                    lowGap={true}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    label={"Standard"}
                    Selectplaceholder={"Select Standard"}
                    isDropdown
                    options={standard}
                    value={standardId}
                    labelClassName={"Label_FontM"}
                    onChange={(e) => {
                      setStandardId(e);
                      setSubjectId("");
                      setSelectedGender("");
                      setShowCoverage(false);
                      setStakeHolder(true);
                      getSubjectDashboard(e.value);
                      setUsersDatas([]);
                    }}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    label={"Subject"}
                    Selectplaceholder={"Select Subject"}
                    isDropdown
                    options={subject}
                    value={subjectId}
                    labelClassName={"Label_FontM"}
                    onChange={(e) => {
                      setSubjectId(e);
                      setSelectedGender("");
                      setShowCoverage(false);
                      setStakeHolder(true);
                      setUsersDatas([]);
                    }}
                    isDisabled={!standardId}
                    // isMulti={true}
                  />
                </div>
                <div className="col-md-4">
                  <Input
                    label={"Gender"}
                    Selectplaceholder={"Select Gender"}
                    isDropdown
                    options={genderOptions}
                    value={selectedGender}
                    onChange={(e) => {
                      setSelectedGender(e);
                      GetDashboardTableData(e);
                      setShowCoverage(false);
                      setStakeHolder(true);
                    }}
                    isDisabled={!subjectId}
                  />
                  {/* <div className="d-flex flex-column w-100 gap-1">
                    <CFormLabel className="col-sm-12 Label_FontM text-align-left">
                      Gender <code>*</code>
                    </CFormLabel>
                    <MultiSelect
                      options={genderOptions}
                      value={selectedGender}
                      id="ms1"
                      onChange={handleGenderChange}
                      placeholder="Name of the project"
                      disabled={!subjectId}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#237E85",
                          primary: "#237E85",
                        },
                      })}
                    />
                  </div> */}
                </div>
              </div>

              <div className="d-flex flex-column gap-1 pt-3">
                <div className="d-flex justify-content-between">
                  <div className="Label_FontDash">
                    List of Stakeholder Coverage Report
                  </div>
                  {state && (
                    <div
                      className={`downReportTableData ${
                        isDownloadingTableData ? "disabled" : ""
                      }`}
                      onClick={() => {
                        if (!isDownloadingTableData) {
                          const cityValue = city ? city.value : "";
                          DownloadExcelReportTableData(state.value, cityValue);
                        }
                      }}
                      style={{
                        opacity: isDownloadingTableData ? 0.6 : 1,
                        pointerEvents: isDownloadingTableData ? "none" : "auto",
                        cursor: isDownloadingTableData
                          ? "not-allowed"
                          : "pointer",
                      }}
                    >
                      {isDownloadingTableData
                        ? "Generating..."
                        : "Download Report"}
                    </div>
                  )}
                </div>

                <div>
                  <Table
                    columns={columns}
                    usersData={usersDatas.length > 0 ? usersDatas : usersData}
                    viewClick={viewClick}
                  />
                </div>
              </div>
            </div>
          </div>

          <Drawer
            open={isOpen}
            onClose={toggleDrawer}
            direction="right"
            enableOverlay={false}
            size={"30%"} // width of drawer
          >
            <div
              className="draw-scroll"
              style={{ background: "rgb(245, 245, 245)" }}
            >
              {showStakeHolder && (
                <>
                  <div className="py-1 px-2 back-admin-map">
                    <div className="d-flex flex-column gap-1">
                      <div className="coun_font">
                        Stakeholder Enrollment of{" "}
                        {selectedState ? selectedState : "India"}
                      </div>
                      <div className="wid-map">
                        <Input
                          label={"State / UT"}
                          isDropdown
                          options={stateCountList
                            .filter((state) => state._id !== null)
                            .map((state) => ({
                              value: state._id,
                              label: state._id,
                            }))}
                          value={
                            stateCountList
                              .filter((state) => state._id !== null)
                              .map((state) => ({
                                value: state._id,
                                label: state._id,
                              }))
                              .find((opt) => opt.value === selectedState) ||
                            null
                          }
                          onChange={handleDropdownChange}
                          placeholder={"Select State / UT"}
                          isClearable={true}
                        />
                      </div>
                    </div>

                    <div
                      // className={`map-container ${selectedState ? "zoomed" : ""}`}
                      style={{
                        textAlign: "center",
                        maxWidth: "150px",
                        margin: "0 auto",
                      }}
                    >
                      <div>
                        <SVGMap
                          map={filteredMap}
                          // locationClassName={getLocationClass}
                        />
                      </div>
                    </div>

                    <div className="d-flex flex-column gap-1">
                      <div className="coun_font">
                        Total Population of{" "}
                        {selectedState ? selectedState : "State / UT"}:{" "}
                        {selectedState
                          ? (
                              stateCountList.find(
                                (state) =>
                                  state._id &&
                                  state._id.toLowerCase() ===
                                    selectedState.toLowerCase()
                              )?.totalUsers || 0
                            ).toLocaleString()
                          : stateCountList
                              .filter((state) => state._id !== null)
                              .reduce(
                                (total, state) =>
                                  total + (state.totalUsers || 0),
                                0
                              )
                              .toLocaleString()}
                      </div>
                      <div className="d-flex align-items-start justify-content-center pt-2 gap-4">
                        <div className="d-flex flex-column gap-1">
                          <div className="stu_Tot_font">
                            Total Students:{" "}
                            <span className="count_font_bl">
                              {selectedState
                                ? (
                                    stateCountList.find(
                                      (state) =>
                                        state._id &&
                                        state._id.toLowerCase() ===
                                          selectedState.toLowerCase()
                                    )?.totalStudents || 0
                                  ).toLocaleString()
                                : stateCountList
                                    .filter((state) => state._id !== null)
                                    .reduce(
                                      (total, state) =>
                                        total + (state.totalStudents || 0),
                                      0
                                    )
                                    .toLocaleString()}
                            </span>
                          </div>
                          <div className="stu_Tot_font">
                            Boys:{" "}
                            <span className="count_font_bl">
                              {selectedState
                                ? (
                                    stateCountList.find(
                                      (state) =>
                                        state._id &&
                                        state._id.toLowerCase() ===
                                          selectedState.toLowerCase()
                                    )?.maleStudents || 0
                                  ).toLocaleString()
                                : stateCountList
                                    .filter((state) => state._id !== null)
                                    .reduce(
                                      (total, state) =>
                                        total + (state.maleStudents || 0),
                                      0
                                    )
                                    .toLocaleString()}
                            </span>
                          </div>
                          <div className="stu_Tot_font">
                            Girls:{" "}
                            <span className="count_font_bl">
                              {selectedState
                                ? (
                                    stateCountList.find(
                                      (state) =>
                                        state._id &&
                                        state._id.toLowerCase() ===
                                          selectedState.toLowerCase()
                                    )?.femaleStudents || 0
                                  ).toLocaleString()
                                : stateCountList
                                    .filter((state) => state._id !== null)
                                    .reduce(
                                      (total, state) =>
                                        total + (state.femaleStudents || 0),
                                      0
                                    )
                                    .toLocaleString()}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex flex-column gap-1">
                          <div className="stu_Tot_font">
                            Total Parents:{" "}
                            <span className="count_font_bl">
                              {selectedState
                                ? (
                                    stateCountList.find(
                                      (state) =>
                                        state._id &&
                                        state._id.toLowerCase() ===
                                          selectedState.toLowerCase()
                                    )?.totalParents || 0
                                  ).toLocaleString()
                                : stateCountList
                                    .filter((state) => state._id !== null)
                                    .reduce(
                                      (total, state) =>
                                        total + (state.totalParents || 0),
                                      0
                                    )
                                    .toLocaleString()}
                            </span>
                          </div>
                          <div className="stu_Tot_font">
                            Total Teachers:{" "}
                            <span className="count_font_bl">
                              {selectedState
                                ? (
                                    stateCountList.find(
                                      (state) =>
                                        state._id &&
                                        state._id.toLowerCase() ===
                                          selectedState.toLowerCase()
                                    )?.totalTeachers || 0
                                  ).toLocaleString()
                                : stateCountList
                                    .filter((state) => state._id !== null)
                                    .reduce(
                                      (total, state) =>
                                        total + (state.totalTeachers || 0),
                                      0
                                    )
                                    .toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="py-2">
                    <div className="px-2 py-1 d-flex flex-column gap-3 back-admin-stake">
                      <div className="d-flex align-items-center gap-2 coun_font">
                        <span>Stakeholder’s Summary of Top Cities</span>
                        <span>
                          <RiArrowRightDoubleFill
                            size={23}
                            className="pointer"
                          />
                        </span>
                      </div>

                      <div className="super-overf">
                        <div className="d-flex align-items-center gap-3">
                          {topCites
                            .filter((city) => city._id !== null)
                            .map((city, index) => {
                              const colorClass =
                                index % 3 === 0
                                  ? "blu_admin"
                                  : index % 3 === 1
                                  ? "oran_admin"
                                  : "gree_admin";
                              const padClass =
                                index % 3 === 0
                                  ? "pad_bot_stak1"
                                  : index % 3 === 1
                                  ? "pad_bot_stak2"
                                  : "pad_bot_stak3";
                              const countFontClass =
                                index % 3 === 0
                                  ? "count_font_bl"
                                  : index % 3 === 1
                                  ? "count_font_or"
                                  : "count_font_gr";

                              return (
                                <div
                                  key={city._id || `city-${index}`}
                                  className={`d-flex flex-column gap-2 ${colorClass}`}
                                >
                                  <div
                                    className={`${padClass} d-flex align-items-center justify-content-between`}
                                  >
                                    <span className="coun_font">
                                      {city._id || "Unknown City"}
                                    </span>
                                    {/* <span>
                                <BsArrowRightCircle size={20} />
                              </span> */}
                                  </div>
                                  <div className="d-flex flex-column gap-2">
                                    <div className="d-flex flex-column">
                                      <div className="d-flex align-items-center gap-3 widthMax">
                                        <span className="stu_Tot_font">
                                          Total Students:{" "}
                                        </span>
                                        <span className={countFontClass}>
                                          {city.totalStudents?.toLocaleString() ||
                                            0}
                                        </span>
                                      </div>
                                      <div className="d-flex align-items-center justify-content-between">
                                        <span className="stu_Tot_font_sub">
                                          Boys:{" "}
                                        </span>
                                        <span className={countFontClass}>
                                          {city.maleStudents?.toLocaleString() ||
                                            0}
                                        </span>
                                      </div>
                                      <div className="d-flex align-items-center justify-content-between">
                                        <span className="stu_Tot_font_sub">
                                          Girls:{" "}
                                        </span>
                                        <span className={countFontClass}>
                                          {city.femaleStudents?.toLocaleString() ||
                                            0}
                                        </span>
                                      </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className="stu_Tot_font">
                                        Total Parents:{" "}
                                      </span>
                                      <span className={countFontClass}>
                                        {city.totalParents?.toLocaleString() ||
                                          0}
                                      </span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className="stu_Tot_font">
                                        Total teachers:{" "}
                                      </span>
                                      <span className={countFontClass}>
                                        {city.totalTeachers?.toLocaleString() ||
                                          0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>

                  <>
                    <div className="px-2 py-1 d-flex flex-column gap-3 back-admin-stake">
                      <div className="d-flex align-items-center gap-2 coun_font">
                        <span>Summary of States / UT</span>
                        <span>
                          <RiArrowRightDoubleFill
                            size={23}
                            className="pointer"
                          />
                        </span>
                      </div>

                      <div className="d-flex flex-column gap-2">
                        <div>
                          <PieChart
                            data={{
                              labels: stateCountList
                                .filter((state) => state._id !== null)
                                .map((state) => state._id),
                              datasets: [
                                {
                                  data: stateCountList
                                    .filter((state) => state._id !== null)
                                    .map((state) => state.totalUsers),
                                  backgroundColor: [
                                    "rgba(255, 99, 132, 0.6)",
                                    "rgba(54, 162, 235, 0.6)",
                                    "rgba(255, 206, 86, 0.6)",
                                    "rgba(75, 192, 192, 0.6)",
                                    "rgba(153, 102, 255, 0.6)",
                                    "rgba(255, 159, 64, 0.6)",
                                    "rgba(199, 199, 199, 0.6)",
                                    "rgba(83, 102, 255, 0.6)",
                                    "rgba(40, 159, 64, 0.6)",
                                    "rgba(210, 99, 132, 0.6)",
                                    "rgba(20, 162, 235, 0.6)",
                                  ],
                                  borderColor: [
                                    "rgba(255, 99, 132, 1)",
                                    "rgba(54, 162, 235, 1)",
                                    "rgba(255, 206, 86, 1)",
                                    "rgba(75, 192, 192, 1)",
                                    "rgba(153, 102, 255, 1)",
                                    "rgba(255, 159, 64, 1)",
                                    "rgba(199, 199, 199, 1)",
                                    "rgba(83, 102, 255, 1)",
                                    "rgba(40, 159, 64, 1)",
                                    "rgba(210, 99, 132, 1)",
                                    "rgba(20, 162, 235, 1)",
                                  ],
                                  borderWidth: 1,
                                },
                              ],
                            }}
                            styleName={"height_pie"}
                            options={options}
                          />
                        </div>

                        <div className="firstPiechartTableDrawer">
                          <table
                            style={{
                              width: "100%",
                              textAlign: "center",
                              border: "1px solid",
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead>
                              <tr style={{ backgroundColor: "#f2f2f2" }}>
                                <th className="super-table-head">State</th>
                                <th className="super-table-head">Students</th>
                                <th className="super-table-head">Boys</th>
                                <th className="super-table-head">Girls</th>
                                <th className="super-table-head">Teachers</th>
                                <th className="super-table-head">Parents</th>
                              </tr>
                            </thead>
                            <tbody>
                              {stateCountList
                                .filter((state) => state._id !== null)
                                .map((state, index) => (
                                  <tr key={state._id || `state-${index}`}>
                                    <td className="super-table-name">
                                      {state._id || "Unknown"}
                                    </td>
                                    <td className="super-table-row">
                                      {state.totalStudents || 0}
                                    </td>
                                    <td className="super-table-row">
                                      {state.maleStudents || 0}
                                    </td>
                                    <td className="super-table-row">
                                      {state.femaleStudents || 0}
                                    </td>
                                    <td className="super-table-row">
                                      {state.totalTeachers || 0}
                                    </td>
                                    <td className="super-table-row">
                                      {state.totalParents || 0}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>

                  {/* <div className="py-2">
                <div className="py-1 px-2 back-admin-map">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="coun_font">Stakeholder Coverage Report</div>
                    <div className="wid-map">
                      <Input
                        label={"State / UT"}
                        isDropdown
                        options={stateCountList
                          .filter((state) => state._id !== null)
                          .map((state) => ({
                            value: state._id,
                            label: state._id,
                          }))}
                        value={
                          stateCountList
                            .filter((state) => state._id !== null)
                            .map((state) => ({
                              value: state._id,
                              label: state._id,
                            }))
                            .find((opt) => opt.value === selectedState1) || null
                        }
                        onChange={handleDropdownChange1}
                        placeholder={"Select State / UT"}
                        isClearable={true}
                      />
                    </div>
                  </div>

                  <div
                    // className={`map-container ${selectedState ? "zoomed" : ""}`}
                    style={{
                      textAlign: "center",
                      maxWidth: "150px",
                      margin: "0 auto",
                    }}
                  >
                    <div>
                      <SVGMap
                        map={filteredMap1}
                        // locationClassName={getLocationClass}
                      />
                    </div>

                    <div className="coun_font">
                      Total Population of{" "}
                      {selectedState1 ? selectedState1 : "State / UT"}:{" "}
                      {selectedState1
                        ? (
                            stateCountList.find(
                              (state) =>
                                state._id &&
                                state._id.toLowerCase() ===
                                  selectedState1.toLowerCase()
                            )?.totalUsers || 0
                          ).toLocaleString()
                        : stateCountList
                            .filter((state) => state._id !== null)
                            .reduce(
                              (total, state) => total + (state.totalUsers || 0),
                              0
                            )
                            .toLocaleString()}
                    </div>
                  </div>

                  <div className="d-flex align-items-start justify-content-center pt-2 gap-4">
                    <div className="d-flex flex-column gap-1">
                      <div className="stu_Tot_font">
                        Total Students:{" "}
                        <span className="count_font_bl">
                          {selectedState1
                            ? (
                                stateCountList.find(
                                  (state) =>
                                    state._id &&
                                    state._id.toLowerCase() ===
                                      selectedState1.toLowerCase()
                                )?.totalStudents || 0
                              ).toLocaleString()
                            : stateCountList
                                .filter((state) => state._id !== null)
                                .reduce(
                                  (total, state) =>
                                    total + (state.totalStudents || 0),
                                  0
                                )
                                .toLocaleString()}
                        </span>
                      </div>
                      <div className="stu_Tot_font">
                        Boys:{" "}
                        <span className="count_font_bl">
                          {selectedState1
                            ? (
                                stateCountList.find(
                                  (state) =>
                                    state._id &&
                                    state._id.toLowerCase() ===
                                      selectedState1.toLowerCase()
                                )?.maleStudents || 0
                              ).toLocaleString()
                            : stateCountList
                                .filter((state) => state._id !== null)
                                .reduce(
                                  (total, state) =>
                                    total + (state.maleStudents || 0),
                                  0
                                )
                                .toLocaleString()}
                        </span>
                      </div>
                      <div className="stu_Tot_font">
                        Girls:{" "}
                        <span className="count_font_bl">
                          {selectedState1
                            ? (
                                stateCountList.find(
                                  (state) =>
                                    state._id &&
                                    state._id.toLowerCase() ===
                                      selectedState1.toLowerCase()
                                )?.femaleStudents || 0
                              ).toLocaleString()
                            : stateCountList
                                .filter((state) => state._id !== null)
                                .reduce(
                                  (total, state) =>
                                    total + (state.femaleStudents || 0),
                                  0
                                )
                                .toLocaleString()}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-1">
                      <div className="stu_Tot_font">
                        Total Parents:{" "}
                        <span className="count_font_bl">
                          {selectedState1
                            ? (
                                stateCountList.find(
                                  (state) =>
                                    state._id &&
                                    state._id.toLowerCase() ===
                                      selectedState1.toLowerCase()
                                )?.totalParents || 0
                              ).toLocaleString()
                            : stateCountList
                                .filter((state) => state._id !== null)
                                .reduce(
                                  (total, state) =>
                                    total + (state.totalParents || 0),
                                  0
                                )
                                .toLocaleString()}
                        </span>
                      </div>
                      <div className="stu_Tot_font">
                        Total Teachers:{" "}
                        <span className="count_font_bl">
                          {selectedState1
                            ? (
                                stateCountList.find(
                                  (state) =>
                                    state._id &&
                                    state._id.toLowerCase() ===
                                      selectedState1.toLowerCase()
                                )?.totalTeachers || 0
                              ).toLocaleString()
                            : stateCountList
                                .filter((state) => state._id !== null)
                                .reduce(
                                  (total, state) =>
                                    total + (state.totalTeachers || 0),
                                  0
                                )
                                .toLocaleString()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="py-2">
                <div className="px-2 py-1 d-flex flex-column gap-3 back-admin-stake">
                  <div className="d-flex align-items-center gap-2 coun_font">
                    <span>Stakeholder Coverage Report of Top Cities</span>
                    <span>
                      <RiArrowRightDoubleFill size={23} className="pointer" />
                    </span>
                  </div>

                  <div className="super-overf">
                    <div className="d-flex align-items-center gap-3">
                      <div className="d-flex flex-column gap-2 blu_admin">
                        <div className="pad_bot_stak1 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Delhi</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_bl d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 oran_admin">
                        <div className="pad_bot_stak2 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Mumbai</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_or d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 gree_admin">
                        <div className="pad_bot_stak3 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Chennai</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_gr d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 oran_admin">
                        <div className="pad_bot_stak2 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Goa</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex align-items-center gap-5">
                            <div className="cov-font-chart">Standard</div>
                            <div className="cov-font-chart text-center">
                              Coverage Report
                            </div>
                          </div>

                          <div className="standard-overf">
                            <div className="d-flex align-items-center gap-5 justify-content-around">
                              <div className="stan_font d-flex flex-column">
                                <div>I</div>
                                <div>II</div>
                                <div>III</div>
                                <div>IV</div>
                                <div>V</div>
                                <div>VI</div>
                                <div>VII</div>
                              </div>
                              <div className="count_font_or d-flex flex-column">
                                <div>50%</div>
                                <div>55%</div>
                                <div>40%</div>
                                <div>60%</div>
                                <div>65%</div>
                                <div>70%</div>
                                <div>51%</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-2 blu_admin">
                        <div className="pad_bot_stak1 d-flex align-items-center justify-content-between">
                          <span className="coun_font">Himachal Pradesh</span>
                          <span>
                            <BsArrowRightCircle size={20} />
                          </span>
                        </div>
                        <div className="d-flex flex-column gap-2">
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center gap-5">
                              <div className="cov-font-chart">Standard</div>
                              <div className="cov-font-chart text-center">
                                Coverage Report
                              </div>
                            </div>

                            <div className="standard-overf">
                              <div className="d-flex align-items-center gap-5 justify-content-around">
                                <div className="stan_font d-flex flex-column">
                                  <div>I</div>
                                  <div>II</div>
                                  <div>III</div>
                                  <div>IV</div>
                                  <div>V</div>
                                  <div>VI</div>
                                  <div>VII</div>
                                </div>
                                <div className="count_font_bl d-flex flex-column">
                                  <div>50%</div>
                                  <div>55%</div>
                                  <div>40%</div>
                                  <div>60%</div>
                                  <div>65%</div>
                                  <div>70%</div>
                                  <div>51%</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="py-2">
                <div className="px-2 py-1 d-flex flex-column gap-3 back-admin-stake">
                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex align-items-center gap-2 coun_font">
                      <span>Stakeholder Coverage Report of States / UT</span>
                      <span>
                        <RiArrowRightDoubleFill
                          size={23}
                          className="pointer"
                          // onClick={() => { setShowMainContent(false); setShowSidePage(true) }}
                        />
                      </span>
                    </div>

                    <div className="w-50">
                      <Input
                        placeholder={"Select Class"}
                        isDropdown
                        adminlabel={true}
                      />
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-2">
                    <div>
                      <PieChart
                        data={data}
                        options={options}
                        styleName={"height_pie"}
                      />
                    </div>

                    <div>
                      <table
                        style={{
                          width: "100%",
                          textAlign: "center",
                          border: "1px solid",
                          borderCollapse: "collapse",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f2f2f2" }}>
                            <th className="super-table-head">State</th>
                            <th className="super-table-head">Students</th>
                            <th className="super-table-head">Boys</th>
                            <th className="super-table-head">Girls</th>
                            <th className="super-table-head">Teachers</th>
                            <th className="super-table-head">Parents</th>
                          </tr>
                        </thead>
                        <tbody>
                          {studentsdata.map((row, index) => (
                            <tr key={index}>
                              <td className="super-table-name">{row.state}</td>
                              <td className="super-table-row">
                                {row.students}
                              </td>
                              <td className="super-table-row">{row.boys}</td>
                              <td className="super-table-row">{row.girls}</td>
                              <td className="super-table-row">
                                {row.teachers}
                              </td>
                              <td className="super-table-row">{row.parents}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div> */}
                </>
              )}

              {showCoverage && (
                <div className="cover-back py-1 px-2">
                  <div className="d-flex align-items-center justify-content-between">
                    {coverReportOpen && !coverUnitOpen && !coverSessionOpen && (
                      <div className="d-flex align-items-center gap-1">
                        <MdOutlineKeyboardArrowLeft
                          size={20}
                          className="nodrop"
                        />
                        <GoHome size={17} className="pointer" />
                        <MdOutlineKeyboardArrowRight
                          size={20}
                          className="nodrop"
                        />
                      </div>
                    )}
                    {!coverReportOpen && coverUnitOpen && !coverSessionOpen && (
                      <div className="d-flex align-items-center gap-1">
                        <MdOutlineKeyboardArrowLeft
                          size={20}
                          className="pointer"
                          onClick={() => {
                            setCoverReportOpen(true);
                            setCoverUnitOpen(false);
                            setCoverSessionOpen(false);
                            setviewedBookName("");
                            setviewedUnitName("");
                          }}
                        />
                        <GoHome size={17} className="pointer" />
                        <MdOutlineKeyboardArrowRight
                          size={20}
                          className="nodrop"
                        />
                      </div>
                    )}
                    {!coverReportOpen && !coverUnitOpen && coverSessionOpen && (
                      <div className="d-flex align-items-center gap-1">
                        <MdOutlineKeyboardArrowLeft
                          size={20}
                          className="pointer"
                          onClick={() => {
                            setCoverReportOpen(false);
                            setCoverUnitOpen(true);
                            setCoverSessionOpen(false);
                            setviewedUnitName("");
                          }}
                        />
                        <GoHome size={17} className="pointer" />
                        <MdOutlineKeyboardArrowRight
                          size={20}
                          className="nodrop"
                        />
                      </div>
                    )}

                    <div>
                      <IoCloseOutline
                        size={20}
                        className="pointer"
                        onClick={() => {
                          setShowCoverage(false);
                          setStakeHolder(true);
                          setbooklistloading(false);
                          setCoverReportOpen(false);
                          setCoverUnitOpen(false);
                          setCoverSessionOpen(false);
                          setviewedBookName("");
                          setviewedUnitName("");
                          setcoverageReport([]);
                          setcoverageReportUnit([]);
                          setcoverageReportSession([]);
                        }}
                      />
                    </div>
                  </div>

                  <div className="px-2 d-flex flex-column gap-2 pt-2 viewReportCoverageHeight">
                    <div>
                      <div className="coun_font">
                        Coverage Report of {coverageName}
                      </div>
                      <div className="stan_font">{coverageSchoolName}</div>
                    </div>

                    {booklistloading && (
                      <>
                        <div
                          style={{
                            height: window.innerHeight - 210 + "px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img src={Subload} alt="" style={{ width: "25%" }} />
                        </div>
                      </>
                    )}
                    <div className="heightCoverage">
                      {coverReportOpen &&
                        !coverUnitOpen &&
                        !coverSessionOpen && (
                          <div className="row justify-content-start py-3 padtwoperen">
                            {coverageReport?.length > 0 &&
                              coverageReport?.map((subject, index) => (
                                <div
                                  key={index}
                                  className="col-md-4 mb-4 d-flex justify-content-center w-100"
                                >
                                  <div className="report-card w-100">
                                    {/* Subject Title */}
                                    <h3
                                      className="report-title text-center cursor-pointer"
                                      onClick={() => {
                                        setCoverUnitOpen(true);
                                        setCoverReportOpen(false);
                                        setCoverSessionOpen(false);
                                        setviewedBookName(
                                          `${
                                            subject?.className
                                              ? `${subject?.className} - `
                                              : ``
                                          }${subject.bookName}`
                                        );
                                        FetchAllUnitsSessions(subject?.bookId);
                                      }}
                                    >
                                      {subject.bookName}{" "}
                                      {subject?.className
                                        ? `(${subject?.className})`
                                        : ``}
                                    </h3>

                                    <div className="d-flex gap10px">
                                      <div className="report-circle">
                                        <div>
                                          {subject?.booksProgress?.student
                                            ?.overAllStudentCount > 0
                                            ? Math.round(
                                                (subject?.booksProgress?.student
                                                  ?.overAllStudentCount *
                                                  100) /
                                                  subject?.booksProgress?.total
                                                    ?.overAllCount
                                              )
                                            : 0}
                                          %
                                        </div>
                                        <div className="report-circlespan">
                                          Book Coverage
                                        </div>
                                      </div>

                                      <div className="w-100">
                                        {/* Items */}
                                        <div className="report-items">
                                          {coverageArr?.length > 0 &&
                                            coverageArr?.map((item, idx) => (
                                              <React.Fragment key={idx}>
                                                {subject?.booksProgress?.total[
                                                  item?.totalCount
                                                ] &&
                                                subject?.booksProgress?.total[
                                                  item?.totalCount
                                                ] > 0 &&
                                                item?.bookStatus ? (
                                                  <div className="report-item">
                                                    <div className="report-label d-flex justify-content-between">
                                                      <span>
                                                        {item.label}{" "}
                                                        <span className="font-weight-600">
                                                          {
                                                            subject
                                                              ?.booksProgress
                                                              ?.student[
                                                              item?.studentCount
                                                            ]
                                                          }
                                                          /
                                                          {
                                                            subject
                                                              ?.booksProgress
                                                              ?.total[
                                                              item?.totalCount
                                                            ]
                                                          }
                                                        </span>
                                                      </span>
                                                      <span className="font-weight-600">
                                                        {`${
                                                          subject?.booksProgress
                                                            ?.total[
                                                            item?.totalCount
                                                          ] === 0
                                                            ? 0
                                                            : subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ]
                                                            ? subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ] >
                                                              subject
                                                                ?.booksProgress
                                                                ?.total[
                                                                item?.totalCount
                                                              ]
                                                              ? "100"
                                                              : Math.round(
                                                                  (subject
                                                                    ?.booksProgress
                                                                    ?.student[
                                                                    item
                                                                      ?.studentCount
                                                                  ] *
                                                                    100) /
                                                                    subject
                                                                      ?.booksProgress
                                                                      ?.total[
                                                                      item
                                                                        ?.totalCount
                                                                    ]
                                                                )
                                                            : 0
                                                        }%`}
                                                      </span>
                                                    </div>
                                                    <div className="report-bar">
                                                      <div
                                                        className="report-bar-fill"
                                                        style={{
                                                          width: `${
                                                            subject
                                                              ?.booksProgress
                                                              ?.total[
                                                              item?.totalCount
                                                            ] === 0
                                                              ? 0
                                                              : subject
                                                                  ?.booksProgress
                                                                  ?.student[
                                                                  item
                                                                    ?.studentCount
                                                                ]
                                                              ? subject
                                                                  ?.booksProgress
                                                                  ?.student[
                                                                  item
                                                                    ?.studentCount
                                                                ] >
                                                                subject
                                                                  ?.booksProgress
                                                                  ?.total[
                                                                  item
                                                                    ?.totalCount
                                                                ]
                                                                ? "100"
                                                                : Math.round(
                                                                    (subject
                                                                      ?.booksProgress
                                                                      ?.student[
                                                                      item
                                                                        ?.studentCount
                                                                    ] *
                                                                      100) /
                                                                      subject
                                                                        ?.booksProgress
                                                                        ?.total[
                                                                        item
                                                                          ?.totalCount
                                                                      ]
                                                                  )
                                                              : 0
                                                          }%`,
                                                        }}
                                                      ></div>
                                                    </div>
                                                  </div>
                                                ) : item.totalCount === "" ? (
                                                  <div className="report-item">
                                                    <div className="report-label d-flex justify-content-between">
                                                      <span>{item.label} </span>
                                                      <span className="font-weight-600">
                                                        {
                                                          subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ]
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </React.Fragment>
                                            ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}

                      {!coverReportOpen &&
                        coverUnitOpen &&
                        !coverSessionOpen && (
                          <div className="row justify-content-start py-3 padtwoperen">
                            {viewedBookName && (
                              <div className="d-flex flex-column align-items-center mb-3">
                                <span className="title-crumb text-left">
                                  {viewedBookName}
                                </span>
                                {viewedUnitName && (
                                  <>
                                    <span className="d-flex align-items-end">
                                      {">>"}
                                    </span>
                                    <span className="title-crumb text-left">
                                      {viewedUnitName}
                                    </span>
                                  </>
                                )}
                              </div>
                            )}
                            {coverageReportUnit?.length > 0 &&
                              coverageReportUnit?.map((subject) => (
                                <div className="col-md-4 mb-4 d-flex justify-content-center w-100">
                                  <div className="report-card w-100">
                                    {/* Subject Title */}

                                    <h3
                                      className="report-title text-center cursor-pointer"
                                      onClick={() => {
                                        console.log(
                                          bookunitSessions,
                                          "bookunitSessions"
                                        );
                                        console.log(
                                          bookunitSessions.filter(
                                            (x) => x?.UnitId === subject?.unitId
                                          ),
                                          "bookunitSessions"
                                        );
                                        setCoverUnitOpen(false);
                                        setCoverReportOpen(false);
                                        setCoverSessionOpen(true);
                                        setviewedUnitName(subject.unitName);
                                        FetchAllSessionAnalytics(
                                          subject?.bookId,
                                          bookunitSessions.filter(
                                            (x) => x?.UnitId === subject?.unitId
                                          )?.length > 0
                                            ? bookunitSessions.filter(
                                                (x) =>
                                                  x?.UnitId === subject?.unitId
                                              )[0]?.SessionDetails
                                            : ""
                                        );
                                        window.scrollTo(0, 0);
                                      }}
                                    >
                                      {subject.unitName}
                                    </h3>

                                    <div className="d-flex gap10px">
                                      <div className="report-circle">
                                        {" "}
                                        <div>
                                          {" "}
                                          {subject?.booksProgress?.student
                                            ?.overAllStudentCount > 0
                                            ? Math.round(
                                                (subject?.booksProgress?.student
                                                  ?.overAllStudentCount *
                                                  100) /
                                                  subject?.booksProgress?.total
                                                    ?.overAllCount
                                              )
                                            : 0}
                                          %{" "}
                                        </div>{" "}
                                        <div className="report-circlespan">
                                          Unit Coverage
                                        </div>{" "}
                                      </div>

                                      <div className="w-100">
                                        {/* Items */}
                                        <div className="report-items">
                                          {coverageArr?.length > 0 &&
                                            coverageArr?.map((item) => (
                                              <>
                                                {subject?.booksProgress?.total[
                                                  item?.totalCount
                                                ] &&
                                                subject?.booksProgress?.total[
                                                  item?.totalCount
                                                ] > 0 &&
                                                item?.unitStatus ? (
                                                  <div className="report-item">
                                                    <div className="report-label d-flex justify-content-between">
                                                      <span>
                                                        {item.label}{" "}
                                                        <span className="font-weight-600">
                                                          {
                                                            subject
                                                              ?.booksProgress
                                                              ?.student[
                                                              item?.studentCount
                                                            ]
                                                          }
                                                          /
                                                          {
                                                            subject
                                                              ?.booksProgress
                                                              ?.total[
                                                              item?.totalCount
                                                            ]
                                                          }
                                                        </span>
                                                      </span>
                                                      <span className="font-weight-600">
                                                        {`${
                                                          subject?.booksProgress
                                                            ?.total[
                                                            item?.totalCount
                                                          ] === 0
                                                            ? 0
                                                            : subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ]
                                                            ? subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ] >
                                                              subject
                                                                ?.booksProgress
                                                                ?.total[
                                                                item?.totalCount
                                                              ]
                                                              ? "100"
                                                              : Math.round(
                                                                  (subject
                                                                    ?.booksProgress
                                                                    ?.student[
                                                                    item
                                                                      ?.studentCount
                                                                  ] *
                                                                    100) /
                                                                    subject
                                                                      ?.booksProgress
                                                                      ?.total[
                                                                      item
                                                                        ?.totalCount
                                                                    ]
                                                                )
                                                            : 0
                                                        }%`}
                                                      </span>
                                                    </div>
                                                    <div className="report-bar">
                                                      <div
                                                        className="report-bar-fill"
                                                        style={{
                                                          width: `${
                                                            subject
                                                              ?.booksProgress
                                                              ?.total[
                                                              item?.totalCount
                                                            ] === 0
                                                              ? 0
                                                              : subject
                                                                  ?.booksProgress
                                                                  ?.student[
                                                                  item
                                                                    ?.studentCount
                                                                ]
                                                              ? subject
                                                                  ?.booksProgress
                                                                  ?.student[
                                                                  item
                                                                    ?.studentCount
                                                                ] >
                                                                subject
                                                                  ?.booksProgress
                                                                  ?.total[
                                                                  item
                                                                    ?.totalCount
                                                                ]
                                                                ? "100"
                                                                : Math.round(
                                                                    (subject
                                                                      ?.booksProgress
                                                                      ?.student[
                                                                      item
                                                                        ?.studentCount
                                                                    ] *
                                                                      100) /
                                                                      subject
                                                                        ?.booksProgress
                                                                        ?.total[
                                                                        item
                                                                          ?.totalCount
                                                                      ]
                                                                  )
                                                              : 0
                                                          }%`,
                                                        }}
                                                      >
                                                        {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : item.totalCount === "" ? (
                                                  <div className="report-item">
                                                    <div className="report-label d-flex justify-content-between">
                                                      <span>{item.label} </span>
                                                      <span className="font-weight-600">
                                                        {
                                                          subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ]
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}

                      {!coverReportOpen &&
                        !coverUnitOpen &&
                        coverSessionOpen && (
                          <div className="row justify-content-start py-3 padtwoperen">
                            {viewedBookName && (
                              <div className="d-flex flex-column align-items-center mb-3">
                                <span className="title-crumb text-left">
                                  {viewedBookName}
                                </span>
                                {viewedUnitName && (
                                  <>
                                    <span className="d-flex align-items-end">
                                      {">>"}
                                    </span>
                                    <span className="title-crumb text-left">
                                      {viewedUnitName}
                                    </span>
                                  </>
                                )}
                              </div>
                            )}
                            {coverageReportSession?.length > 0 &&
                              coverageReportSession?.map((subject) => (
                                <div className="col-md-4 mb-4 d-flex justify-content-center w-100">
                                  <div className="report-card w-100">
                                    {/* Subject Title */}

                                    <h3 className="report-title text-center">
                                      {subject.SessionName}
                                    </h3>

                                    <div className="d-flex gap10px">
                                      <div className="report-circle">
                                        {" "}
                                        <div>
                                          {" "}
                                          {subject?.booksProgress?.student
                                            ?.overAllStudentCount > 0
                                            ? Math.round(
                                                (subject?.booksProgress?.student
                                                  ?.overAllStudentCount *
                                                  100) /
                                                  subject?.booksProgress?.total
                                                    ?.overAllCount
                                              )
                                            : 0}
                                          %{" "}
                                        </div>{" "}
                                        <div className="report-circlespan">
                                          {subject.SessionName.includes("Page")
                                            ? `Page Coverage`
                                            : subject.SessionName.includes(
                                                "Session"
                                              )
                                            ? `Session Coverage`
                                            : `Session/Page Coverage`}
                                        </div>{" "}
                                      </div>

                                      <div className="w-100">
                                        {/* Items */}
                                        <div className="report-items">
                                          {coverageArr?.length > 0 &&
                                            coverageArr?.map((item) => (
                                              <>
                                                {subject?.booksProgress?.total[
                                                  item?.totalCount
                                                ] &&
                                                subject?.booksProgress?.total[
                                                  item?.totalCount
                                                ] > 0 &&
                                                item?.sessionStatus ? (
                                                  <div className="report-item">
                                                    <div className="report-label d-flex justify-content-between">
                                                      <span>
                                                        {item.label}{" "}
                                                        <span className="font-weight-600">
                                                          {
                                                            subject
                                                              ?.booksProgress
                                                              ?.student[
                                                              item?.studentCount
                                                            ]
                                                          }
                                                          /
                                                          {
                                                            subject
                                                              ?.booksProgress
                                                              ?.total[
                                                              item?.totalCount
                                                            ]
                                                          }
                                                        </span>
                                                      </span>
                                                      <span className="font-weight-600">
                                                        {`${
                                                          subject?.booksProgress
                                                            ?.total[
                                                            item?.totalCount
                                                          ] === 0
                                                            ? 0
                                                            : subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ]
                                                            ? subject
                                                                ?.booksProgress
                                                                ?.student[
                                                                item
                                                                  ?.studentCount
                                                              ] >
                                                              subject
                                                                ?.booksProgress
                                                                ?.total[
                                                                item?.totalCount
                                                              ]
                                                              ? "100"
                                                              : Math.round(
                                                                  (subject
                                                                    ?.booksProgress
                                                                    ?.student[
                                                                    item
                                                                      ?.studentCount
                                                                  ] *
                                                                    100) /
                                                                    subject
                                                                      ?.booksProgress
                                                                      ?.total[
                                                                      item
                                                                        ?.totalCount
                                                                    ]
                                                                )
                                                            : 0
                                                        }%`}
                                                      </span>
                                                    </div>
                                                    <div className="report-bar">
                                                      <div
                                                        className="report-bar-fill"
                                                        style={{
                                                          width: `${
                                                            subject
                                                              ?.booksProgress
                                                              ?.total[
                                                              item?.totalCount
                                                            ] === 0
                                                              ? 0
                                                              : subject
                                                                  ?.booksProgress
                                                                  ?.student[
                                                                  item
                                                                    ?.studentCount
                                                                ]
                                                              ? subject
                                                                  ?.booksProgress
                                                                  ?.student[
                                                                  item
                                                                    ?.studentCount
                                                                ] >
                                                                subject
                                                                  ?.booksProgress
                                                                  ?.total[
                                                                  item
                                                                    ?.totalCount
                                                                ]
                                                                ? "100"
                                                                : Math.round(
                                                                    (subject
                                                                      ?.booksProgress
                                                                      ?.student[
                                                                      item
                                                                        ?.studentCount
                                                                    ] *
                                                                      100) /
                                                                      subject
                                                                        ?.booksProgress
                                                                        ?.total[
                                                                        item
                                                                          ?.totalCount
                                                                      ]
                                                                  )
                                                              : 0
                                                          }%`,
                                                        }}
                                                      >
                                                        {/* <span className="report-bar-percent">
                                      {`${subject?.booksProgress?.total[item?.totalCount] === 0 ? 0 : (subject?.booksProgress?.student[item?.studentCount] ? subject?.booksProgress?.student[item?.studentCount] > subject?.booksProgress?.total[item?.totalCount] ? "100" : Math.round((subject?.booksProgress?.student[item?.studentCount] * 100)/subject?.booksProgress?.total[item?.totalCount]) : 0)}%`}
                                    </span> */}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : item.totalCount === "" &&
                                                  item?.type !== "bookmarks" ? (
                                                  <div className="report-item">
                                                    <div className="report-label d-flex justify-content-between">
                                                      <span>{item.label} </span>
                                                      <span className="font-weight-600">
                                                        {
                                                          subject?.booksProgress
                                                            ?.student[
                                                            item?.studentCount
                                                          ]
                                                        }
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <></>
                                                )}
                                              </>
                                            ))}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Drawer>
        </div>
      )}

      {feedBackFormOpen && (
        <div
          className="background_color"
          style={{ height: `${window.innerHeight}px`, overflowY: "auto" }}
        >
          <div className="row px-3 py-3">
            <div className="col-md-4">
              <Input
                label={"User Type"}
                Selectplaceholder={"Select User Type"}
                isDropdown
                labelClassName={"Label_FontM"}
                value={userTypeId}
                options={userTypeOptions}
                onChange={(e) => {
                  setUserTypeId(e);
                  setClassId("");
                  setUsersDataFeedBack([]);
                }}
              />
            </div>
            <div className="col-md-4">
              <Input
                label={"Class"}
                Selectplaceholder={"Select Class"}
                isDropdown
                labelClassName={"Label_FontM"}
                value={classId}
                options={classOptions}
                onChange={(e) => {
                  setClassId(e);
                  GetFeedbackReport(e.value, userTypeId.value, e.label);
                }}
                isDisabled={!userTypeId?.value}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end align-items-center w-100 px-3">
            {usersDataFeedBack.length > 0 && (
              <div
                className="feedback-btn downReport"
                style={{ width: "140px" }}
                onClick={downloadExcelReport}
              >
                Download Report
              </div>
            )}
          </div>

          <div className="px-3">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "300px" }}
              >
                <div
                  className="spinner-border text-primary"
                  role="status"
                ></div>{" "}
                &nbsp;
                <span className="fw-bold">Loading...</span>
              </div>
            ) : (
              <Table columns={FeedBackcolumns} usersData={usersDataFeedBack} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default SuperAdminPage;
